module.exports = __webpack_public_path__ + "img/cost-icon__asadores.5d7b217b.svg";